import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.div ``;
const Track = styled(m.ul) `
  display: flex;
`;
const MotionTrackStyles = {
    Container,
    Track,
};
export default MotionTrackStyles;
